import { FormGroup, AbstractControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { forwardRef } from '@angular/core';

export class FormUtils {
    static getErrorMessages(
        formRef: FormGroup,
        validationMessages: any,
        formErrors: any
    ): any {
        if (!formRef) {
            return;
        }
        let errorMessages: any = {};

        for (const field of Object.keys(formErrors)) {
            // Clear previous error message (if any)
            errorMessages[field] = '';
            const control = formRef.get(field);

            if (control && !control.valid && control.dirty) {
                const messages = validationMessages[field];
                for (const key of Object.keys(control.errors)) {
                    errorMessages[field] += messages[key] + ' ';
                }
            }
        }

        return errorMessages;
    }
}

/**
 * Returns the first invalid form control and key from a form group.
 * @param formGroup
 * @returns {undefined|string}
 */
export function getInvalidFormItem(
    formGroup: FormGroup
): { formControlName: string; formControl: AbstractControl } {
    return Object.keys(formGroup.controls)
        .map((formControlName) => {
            return {
                formControlName,
                formControl: formGroup.get(formControlName),
            };
        })
        .find((formItem: any) => formItem.formControl.invalid);
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function getValueAccessorProvider(componentClass: Function) {
    return {
        provide: NG_VALUE_ACCESSOR,
        // eslint-disable-next-line @angular-eslint/no-forward-ref
        useExisting: forwardRef(() => componentClass),
        multi: true,
    };
}
